import { render, staticRenderFns } from "./ring-cell.vue?vue&type=template&id=2f973f2a&scoped=true"
import script from "./ring-cell.vue?vue&type=script&lang=js"
export * from "./ring-cell.vue?vue&type=script&lang=js"
import style0 from "./ring-cell.vue?vue&type=style&index=0&id=2f973f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f973f2a",
  null
  
)

export default component.exports